// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kasgQ","main-image":"Header_main-image__KKmbl"};